import WaterCold from "@/assets/icon/svgs/WaterCold.svg";
import WaterHot from "@/assets/icon/svgs/WaterHot.svg";
import Fire from "@/assets/icon/svgs/Fire.svg";
import Flash from "@/assets/icon/svgs/Flash.svg";
import Thermometer from "@/assets/icon/svgs/Thermometer.svg";

import FireGreen from "@/assets/icon/svgs/FireGreen.svg";
import FlashOrange from "@/assets/icon/svgs/FlashOrange.svg";
import ThermometerPink from "@/assets/icon/svgs/ThermometerPink.svg";
import Other from "@/assets/icon/svgs/Other.svg";
import Funds from "@/assets/icon/svgs/Funds.svg";
import TotalBill from "@/assets/icon/svgs/TotalBill.svg";

export const sensorTypes = {
  cold_water: "cold_water",
  hot_water: "hot_water",
  heating: "heating",
  electricity: "electricity",
  gas: "gas",
} as const;

export const sensorTypesAnalysis = {
  total_bill: "total_bill",
  cold_water: "cold_water",
  hot_water: "hot_water",
  heating: "heating",
  electricity: "electricity",
  gas: "gas",
  utility_and_funds: "utility_and_funds",
  other: "other",
} as const;

export const sensorUnitMap: { [key in keyof typeof sensorTypes]: string } = {
  electricity: "kWh",
  heating: "kWh",
  cold_water: "m³",
  hot_water: "m³",
  gas: "m³",
};

export const sensorTypeIconMap: { [key in keyof typeof sensorTypes]: string } =
{
  electricity: Flash,
  hot_water: WaterHot,
  heating: Thermometer,
  cold_water: WaterCold,
  gas: Fire,
};

export const sensorTypeIconMapColors: { [key in keyof typeof sensorTypesAnalysis]: string } =
{
  total_bill: TotalBill,
  electricity: FlashOrange,
  hot_water: WaterHot,
  heating: ThermometerPink,
  cold_water: WaterCold,
  gas: FireGreen,
  utility_and_funds: Funds,
  other: Other,
};

export const unitOptions = {
  total_bill: ["Euro"],
  cold_water: ["Euro", "m³"],
  hot_water: ["Euro", "m³"],
  heating: ["Euro", "Gcal"],
  gas: ["Euro", "m³"],
  electricity: ["Euro", "kWh"],
  utility_and_funds: ["Euro"],
  other: ["Euro"],
};